import getDOMfromString from '../../../helpers/getDOMfromString';

/**
 * Generates home icon/button
 *
 * @param {Object} config - options for btn
 * @returns {HTMLElement|string} - button/button string
 */
const createLinkBtn = config => {
    const {customClasses = [], color = '#fff', onClick, htmlStr = false, iconOnly = false, label} = config ?? {};
    const customClassesStr = Array.isArray(customClasses) ? customClasses.join(' ') : '';
    let elStr = ``;

    const svgStr = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19 11.5V19H5.00003V11.4792C4.5417 11.1597 4.25351 10.75 4.13545 10.25C4.01739 9.75 4.02087 9.22222 4.14587 8.66667L5.45837 5H18.5417L19.8542 8.66667C19.9792 9.22222 19.9792 9.75 19.8542 10.25C19.7292 10.75 19.4445 11.1667 19 11.5ZM13.8334 10.5C14.125 10.5 14.3716 10.4028 14.573 10.2083C14.7743 10.0139 14.8611 9.77778 14.8334 9.5L14.3334 6.5H12.8334V9.5C12.8334 9.77778 12.9306 10.0139 13.125 10.2083C13.3195 10.4028 13.5556 10.5 13.8334 10.5ZM10.1667 10.5C10.4445 10.5 10.6806 10.4028 10.875 10.2083C11.0695 10.0139 11.1667 9.77778 11.1667 9.5V6.5H9.6667L9.1667 9.5C9.13892 9.77778 9.22573 10.0139 9.42712 10.2083C9.62851 10.4028 9.87503 10.5 10.1667 10.5ZM6.50003 10.5C6.75003 10.5 6.96878 10.4236 7.15628 10.2708C7.34378 10.1181 7.45142 9.92361 7.4792 9.6875L8.00003 6.5H6.50003L5.56253 9.16667C5.45142 9.48611 5.49309 9.78819 5.68753 10.0729C5.88198 10.3576 6.15281 10.5 6.50003 10.5ZM17.5 10.5C17.8473 10.5 18.1216 10.3576 18.323 10.0729C18.5243 9.78819 18.5695 9.48611 18.4584 9.16667L17.5 6.5H16L16.5209 9.6875C16.5486 9.92361 16.6598 10.1181 16.8542 10.2708C17.0486 10.4236 17.2639 10.5 17.5 10.5ZM6.50003 17.5H17.5V12C17.1528 12 16.823 11.934 16.5105 11.8021C16.198 11.6701 15.9167 11.4653 15.6667 11.1875C15.4167 11.4653 15.1355 11.6701 14.823 11.8021C14.5105 11.934 14.1806 12 13.8334 12C13.4861 12 13.1598 11.9306 12.8542 11.7917C12.5486 11.6528 12.2639 11.4514 12 11.1875C11.7639 11.4514 11.4861 11.6528 11.1667 11.7917C10.8473 11.9306 10.5139 12 10.1667 12C9.81948 12 9.49309 11.941 9.18753 11.8229C8.88198 11.7049 8.59726 11.4931 8.33337 11.1875C8.02781 11.4931 7.72573 11.7049 7.42712 11.8229C7.12851 11.941 6.81948 12 6.50003 12V17.5Z" fill="${color}"/>
    </svg>`;

    if (iconOnly) {
        elStr = svgStr;
    } else {
        elStr = `<button type="button" aria-label="${label}" title="${label}" class="${customClassesStr}">${svgStr}</button>`;
    }

    if (htmlStr) {
        return elStr;
    }

    // DOM element
    const el = getDOMfromString(elStr);

    if (onClick) {
        el.onclick = onClick;
    }

    return el;
};

export default createLinkBtn;
